(ns app.front.view.group.admin.form-schemas.subs
  (:require [ajax.core :refer [POST]]
            [app.domain.form.form-editor-util :as form-editor-util]
            [app.domain.form.i18n :as form-i18n]
            [app.domain.form.schema :as form-schema]
            [app.domain.party-role.model :as role-model]
            [app.front.entities :as entities]
            [app.front.file.upload :as upload]
            [app.front.ui.dnd :as dnd]
            [app.front.util :as futil]
            [app.front.view.group.admin.form-schemas.util :as form-schemas-util]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.profile.licences :as licence]
            [app.front.view.system-of-units.toggle :as sou-toggle]
            [clojure.set :as set]
            [clojure.string :as str]
            [clojure.walk :as walk]
            [core.domain.system-of-units :as sou]
            [core.front.event :refer [>evt]]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-translation-entries
  (fn [_ [_ group-id]]
    {:comm/command {:command    :group/translation-entries
                    :method     :post
                    :data       {:group-id group-id
                                 :keys     form-i18n/localized-attrs-with-defaults}
                    :on-success [::fetch-translation-entries.success group-id]}}))

(rf/reg-event-fx ::fetch-translation-entries.success
  (fn [{:keys [db]} [_ group-id _ resp]]
    {:db (assoc-in db [::translations group-id] resp)}))

(rf/reg-sub ::translation-entries
  (fn [db]
    (::translations db {})))

(rf/reg-sub ::translation-entries-for-group
  :<- [::translation-entries]
  :<- [::group-id-from-route]
  :<- [form-schemas-util/locales-sub]
  (fn [[templates group-id locales]]
    (-> templates
        (get group-id)
        (select-keys locales))))

(defn translations-for-key
  "Return the translations entries for a key for all languages.

  Replaces any indexed tempura placeholders (%1) with the corresponding
  named placeholders (%some-placeholder%)."
  [translation-entries placeholders k]
  (p/map-vals
    (fn [entries-for-a-lang]
      (->> placeholders
           (map-indexed (fn [idx placeholder]
                          [(str "%" (inc idx)) placeholder]))
           (reduce
             (fn [text [pattern placeholder]]
               (str/replace text pattern placeholder))
             (get entries-for-a-lang k))))
    translation-entries))

(rf/reg-sub ::translation-entries-for-key
  :<- [::translation-entries-for-group]
  (fn [entries [_ k]]
    (when (form-i18n/localized-attrs-with-defaults k)
      (translations-for-key
        entries
        (form-i18n/localized-placeholders k)
        k))))

(defn find-field-by-id [id-to-find {:keys [id] :as schema}]
  (if (= id id-to-find)
    schema
    (->> (form-editor-util/form-el->children schema)
         (some (partial find-field-by-id id-to-find)))))


(defn order-number-for-new-child [form-element]
  (->> form-element
       form-editor-util/form-el->children
       (keep #(some-> % :order inc))
       (into [0])
       (apply max)))


(def db-path-to-editor-data [::form-schema :editor-data])


(defn path->db-path [path]
  (into db-path-to-editor-data path))


(rf/reg-sub ::form-schema #(get % ::form-schema))


(rf/reg-sub ::editor-data
  :<- [::form-schema]
  :-> :editor-data)


(defn form-el->condition-fields [form-element]
  (into
    (if (->> form-element
             :type
             (contains? form-schemas-util/field-types-for-conditions))
      [form-element]
      [])
    (->> (form-editor-util/form-el->children form-element)
         (mapcat form-el->condition-fields))))


(rf/reg-sub ::fields-for-conditions
  ;; Returns those fields that can be referenced in conditions
  :<- [::editor-data]
  :-> form-el->condition-fields)

(rf/reg-sub ::root-element
  :<- [::editor-data]
  #(get % 0))

(rf/reg-sub ::schema-name
  :<- [::root-element]
  #(get-in % [:attributes :label]))

(rf/reg-sub ::original-schema-name
  :<- [::form-schema]
  :-> :original-name)


(rf/reg-sub ::original-locked-when-signed-off
  :<- [::schema-from-route]
  :-> :form.schema/locked-when-signed-off?)


(rf/reg-sub ::original-editor-data
  :<- [::form-schema]
  :-> :original-editor-data)


(rf/reg-sub ::form-edit?
  :<- [::form-schema]
  :-> :form-edit?)


(rf/reg-sub ::inherited?
  :<- [::form-schema]
  :-> :inherited?)


(rf/reg-sub ::fetching-schema?
  :<- [::form-schema]
  :-> :fetching-schema?)


(rf/reg-sub ::id-of-selected-form-el
  :<- [::form-schema]
  :-> :id-of-selected-form-el)


(rf/reg-sub ::changes-to-schema?
  :<- [::editor-data]
  :<- [::original-editor-data]
  :<- [::schema-name]
  :<- [::original-schema-name]
  :<- [::locked-when-signed-off?]
  :<- [::original-locked-when-signed-off]
  (fn [[editor-data original-editor-data name original-name locked-when-signed-off? original-locked-when-signed-off] _]
    (or (not= editor-data original-editor-data)
        (not= name original-name)
        (not= (true? locked-when-signed-off?) (true? original-locked-when-signed-off)))))


(rf/reg-sub ::required-fields-filled?
  :<- [::root-element]
  (fn [root-element]
    (some->> root-element (form-schemas-util/required-fields-filled? true))))


(rf/reg-sub ::conflicting-fields
  :<- [::root-element]
  (fn [root-element]
    (some->> root-element (form-schemas-util/find-conflicting-fields true :conflicting-field))))

(rf/reg-sub ::form-field+types
  :<- [::editor-data]
  (fn [form _]
    (->> form
         form-editor-util/map-presentation->form-fields
         (map (juxt (comp :field :attributes) :type)))))

(rf/reg-sub ::no-locally-duplicate-fields?
  :<- [::form-field+types]
  (fn [field+types _]
    (->> field+types
         (map first)
         frequencies
         (some (comp #(> % 1) second))
         nil?)))

(rf/reg-sub ::no-locally-conflicting-fields?
  :<- [::no-locally-duplicate-fields?]
  :<- [::form-field+types]
  (fn [[no-duplicates? field+types] _]
    (or no-duplicates?
        (->> field+types
             distinct
             (group-by first)
             (filter #(-> % val count (> 1)))
             empty?))))


(rf/reg-sub ::invalid-fields
  :<- [::form-field+types]
  (fn [field+types _]
    (->> field+types
         (keep (fn [field+type]
                 (let [field-key (-> field+type first name)]
                   (when (form-schemas-util/field-key-max-length-exceeded? field-key)
                     field+type))))
         seq)))


(rf/reg-sub ::save-disabled?
  :<- [::changes-to-schema?]
  :<- [::required-fields-filled?]
  :<- [::conflicting-fields]
  :<- [::no-locally-conflicting-fields?]
  :<- [::invalid-fields]
  (fn [[changes-to-schema? required-fields-filled? conflicting-fields no-locally-conflicting-fields? invalid-fields] _]
    (or (not changes-to-schema?)
        (not required-fields-filled?)
        (boolean (seq conflicting-fields))
        (not no-locally-conflicting-fields?)
        (boolean invalid-fields))))


(rf/reg-sub ::selected-form-element
  :<- [::editor-data]
  :<- [::id-of-selected-form-el]
  (fn [[schema id] _]
    (when id
      (find-field-by-id id schema))))


(rf/reg-sub ::existing-field-selected?
  (fn [[_ path]]
    (rf/subscribe [::form-element-by-path path]))
  (fn [form-element _]
    (-> form-element :existing-field some?)))


(rf/reg-sub ::id-is-selected?
  :<- [::id-of-selected-form-el]
  (fn [selected-id [_ id]]
    (= selected-id id)))


(rf/reg-sub ::form-element-by-path
  :<- [::editor-data]
  (fn [schema [_ path]]
    (when path
      (get-in schema path))))


(rf/reg-sub ::available-sou-units
  :<- [::sou-toggle/default-system-of-units]
  :-> sou/system-of-units->available-units)


(rf/reg-sub ::attr-unit-choices
  :<- [::available-sou-units]
  (fn [units]
    (into (sorted-map-by (fn [k1 k2]
                           (compare (:label (k2 units))
                                    (:label (k1 units)))))
          units)))


(rf/reg-sub ::schema-id-from-route
  :<- [:route/match]
  (fn [match]
    (get-in match [:parameters :path :schema-id])))


(rf/reg-sub ::group-id-from-route
  :<- [:route/match]
  (fn [match]
    (get-in match [:parameters :path :group-id])))


(rf/reg-sub ::locked-when-signed-off?
  :<- [::form-schema]
  :-> :locked-when-signed-off?)


(rf/reg-sub ::schema-from-route
  :<- [::entities/context]
  :<- [::schema-id-from-route]
  (fn [[ctx schema-id] _]
    (entities/find-entity ctx schema-id)))


(rf/reg-sub ::schema-latest-change-ts
  :<- [::schema-from-route]
  (fn [schema]
    (-> schema :latest-change :ts)))


(rf/reg-sub ::schema-version
  :<- [::schema-from-route]
  :-> :form.schema/version)


(rf/reg-sub ::schema-type
  :<- [::schema-from-route]
  :-> form-schema/resolve-schema-type)


(rf/reg-sub ::schema-is-authority-form?
  :<- [::schema-from-route]
  :-> form-schemas-util/is-authority-form-schema?)

(rf/reg-sub ::schema-export-url
  :<- [::group-id-from-route]
  :<- [::schema-id-from-route]
  (fn [[group-id schema-id] _]
    (str "/api/command/group/export-data-schema-of-form-schema?"
         "schema-id="
         schema-id
         "&authority-group-id="
         group-id)))


(rf/reg-sub ::available-default-value-sources
  :<- [::schema-type]
  (fn [schema-type [_ field-type]]
    (cond-> [:form.schema/default-value-no]

      (#{:select :radio-button-group} field-type)
      (conj :form.schema/default-value-choice)

      (= :input field-type)
      (conj :form.schema/default-value-workspace-attribute
            :form.schema/default-value-string)

      (and (= :form.schema.type/role-specific schema-type)
           (= :input field-type))
      (conj :form.schema/default-value-party-licence))))


(rf/reg-sub ::default-licence-choices
  :<- [::licence/licence-types]
  :-> identity)


(rf/reg-sub ::first-default-licence
  :<- [::default-licence-choices]
  :-> first)


(rf/reg-sub ::init-values-for-default-value
  :<- [::first-default-licence]
  (fn [licence [_ form-el]]
    (let [child-values (form-editor-util/form-el->child-values form-el)]
      ;; Provide sane defaults when changing type
      {:form.schema/default-value-string              ""
       :form.schema/default-value-choice              (first child-values)
       :form.schema/default-value-workspace-attribute [:property/zoning]
       :form.schema/default-value-party-licence       licence})))


(rf/reg-event-fx ::scroll-to-bottom
  (fn [_ _]
    (futil/scroll-to-bottom)))


(rf/reg-event-fx ::scroll-to-top
  (fn [_ _]
    (futil/scroll-to-top)))


;;
;; Events for saving, deleting and fetching a form schema
;;


(defn- find-vals-of-attr [attr schema]
  (when (map? schema)
    (concat [(get schema attr)]
            (->> (form-editor-util/form-el->children schema)
                 (mapcat (partial find-vals-of-attr attr))))))


(defn editor-data->next-id [editor-data]
  (some->> editor-data
           (find-vals-of-attr :id)
           seq
           (apply max)
           inc))


(defn update-all-form-elements [update-fn editor-data]
  (walk/prewalk
    (fn [form]
      (if (map? form)
        (update-fn form)
        form))
    editor-data))


(defn set-editor-data
  [{:keys [db editing-schema? inherited? editor-data data-schema schema-name override-curr-data? locked-when-signed-off?]}]
  (cond-> (-> (assoc-in db [::form-schema :fetching-schema?] false)
              (assoc-in [::form-schema :inherited?] inherited?))

    editing-schema?
    (update ::form-schema
            merge
            {:original-editor-data (or (update-all-form-elements
                                         (fn [form-element]
                                           ;; Clear all the new and existing field statuses when data has been saved.
                                           (dissoc form-element :new-field? :existing-field))
                                         (get-in db [::form-schema :editor-data]))
                                       editor-data)
             :original-name        schema-name})

    (and editing-schema? override-curr-data?)
    (update ::form-schema merge {:editor-data             editor-data
                                 :schema-name             schema-name
                                 :next-id                 (editor-data->next-id editor-data)
                                 :locked-when-signed-off? locked-when-signed-off?
                                 ;; open edit-view straight away when schema does not have actual content
                                 :form-edit?              (-> data-schema
                                                              form-schema/data-schema-has-content?
                                                              not)})))


(rf/reg-event-fx ::fetch-form-schema.success
  (fn [{:keys [db]} [_ schema-id override-curr-data? status resp]]
    (let [schema          (get resp schema-id)
          editor-data     (-> schema :form.schema/data-schema form-editor-util/schema-data->map)
          inherited?      (not= (::gas/group-id db)
                                (:domain/authority-group schema))
          editing-schema? (-> (get-in db [::form-schema :db/id])
                              (= schema-id))]
      {:db       (set-editor-data (util/mmap {:data-schema             (:form.schema/data-schema schema)
                                              :schema-name             (:form.schema/name schema)
                                              :inherited?              inherited?
                                              :locked-when-signed-off? (:form.schema/locked-when-signed-off? schema)}
                                             db
                                             editing-schema?
                                             editor-data
                                             override-curr-data?))
       :dispatch [::entities/merge-entity-db status resp]})))


(rf/reg-event-fx ::fetch-form-schema
  (fn [{:keys [db]} [_ group-id schema-id]]
    {:db           (-> db
                       (assoc-in [::form-schema :db/id] schema-id)
                       (assoc-in [::form-schema :fetching-schema?] true))
     :comm/command {:command    :group/form-schema-entity
                    :method     :get
                    :data       {:authority-group-id group-id
                                 :schema-id          schema-id}
                    :on-success [::fetch-form-schema.success schema-id true]}}))

(rf/reg-event-fx ::save-form-schema-success
  (fn [_cofx [_ schema-id status resp]]
    {:fx [[:dispatch [::fetch-form-schema.success schema-id false status resp]]
          [:dispatch [::cancel-form-edit]]]}))

(rf/reg-sub ::available-fields
  :<- [::fields-for-conditions]
  (fn [available-fields [_ attributes extracted-keys]]
    (-> (->> available-fields
             (map (comp :field :attributes))
             (remove #(= (:field attributes) %))
             distinct
             (remove nil?)
             set)
        (set/difference extracted-keys)
        sort)))

(rf/reg-sub ::vals-for-field
  :<- [::fields-for-conditions]
  (fn [available-fields [_ selected-field]]
    (->> (p/find-first available-fields #(-> % :attributes :field (= selected-field)))
         form-schemas-util/values-for-condition-field
         (remove nil?)
         distinct)))

(rf/reg-event-fx ::save-form-schema
  (fn [{:keys [db]} [_ group-id schema-id]]
    (let [new-name                (get-in db [::form-schema :editor-data 0 :attributes :label])
          locked-when-signed-off? (get-in db [::form-schema :locked-when-signed-off?])]
      {:comm/command {:command    :group/form-schema-data
                      :method     :post
                      :data       (-> {:authority-group-id group-id
                                       :schema-id          schema-id
                                       :new-data           (-> db
                                                               (get-in [::form-schema :editor-data])
                                                               form-editor-util/map-presentation->schema-data)
                                       :new-name           new-name}
                                      (p/assoc-if :locked-when-signed-off? locked-when-signed-off?))
                      :on-success [::save-form-schema-success schema-id]
                      :notify     {:success :form.schema/save.success}}})))

(rf/reg-event-db ::save-condition
  (fn [db [_ {:keys [path] :as save-data}]]
    (let [attr-path    (->> (concat [::form-schema :editor-data] path [:attributes])
                            vec)
          attributes   (get-in db attr-path)
          updated-cond (form-schemas-util/save-condition attributes save-data)]
      (assoc-in db attr-path (assoc attributes :condition updated-cond)))))

(rf/reg-event-db ::delete-condition
  (fn [db [_ fd]]
    (->> (assoc fd :editor-data db-path-to-editor-data)
         (form-schemas-util/update-db-after-delete db))))

(rf/reg-event-fx ::delete-form-schema.success
  (fn [_ [_ group-id status resp]]
    {:route/push {:route  :view/group.admin.forms
                  :params {:group-id group-id}}
     :dispatch   [::entities/apply-changes status resp]}))


(rf/reg-event-fx ::delete-form-schema
  (fn [_ [_ group-id schema-db-id]]
    {:comm/command {:command    :group/delete-form-schema
                    :method     :post
                    :data       {:authority-group-id group-id
                                 :schema-id          schema-db-id}
                    :on-success [::delete-form-schema.success group-id]
                    :notify     {:success :form.schema/delete.success}}}))


(defn- stop-tracking-file
  [component-id file-hash]
  (>evt [::upload/remove-pending-file component-id :placeholder])
  (>evt [::upload/remove-pending-file component-id file-hash]))

(defn import-form-data-schema-file
  [target-schema-db-id {:keys [file component-id file-hash]}]
  (>evt [::upload/add-pending-file component-id file-hash])
  (POST (str "/api/command/group/import-form-data-schema?target-form-schema-id=" target-schema-db-id)
    {:headers       {"Content-Type" "application/edn"}
     :body          file
     :error-handler (fn [{:keys [status response]}]
                      (stop-tracking-file component-id file-hash)
                      (>evt [::upload/upload-failure (util/mmap {:md5 file-hash} component-id) status response]))
     :handler       (fn [response]
                      (>evt [::fetch-form-schema.success target-schema-db-id true 200 response])
                      (stop-tracking-file component-id file-hash)
                      (>evt [:notifications/add :toast :success :success :form.schema/import-schema.success]))}))


(rf/reg-event-db ::rename
  (fn [db [_ new-name]]
    (assoc-in db [::form-schema :editor-data 0 :attributes :label] new-name)))


(rf/reg-event-db ::form-edit-toggle
  (fn [db [_ value]]
    (assoc-in db [::form-schema :form-edit?] value)))


(rf/reg-event-db ::unselect-form-element
  (fn [db _]
    (-> db
        (p/dissoc-in [::form-schema :id-of-selected-form-el])
        (p/dissoc-in [::form-schema :form-field-search-open?]))))


(rf/reg-event-db ::quit-form-edit
  (fn [db _]
    (dissoc db ::form-schema)))


(rf/reg-event-fx ::cancel-form-edit
  (fn [{:keys [db]} _]
    (let [original-editor-data (get-in db [::form-schema :original-editor-data])
          original-schema-name (get-in db [::form-schema :original-name])]
      {:db         (-> db
                       (assoc-in [::form-schema :editor-data] original-editor-data)
                       (assoc-in [::form-schema :schema-name] original-schema-name))
       :dispatch-n [[::form-edit-toggle false]
                    [::unselect-form-element]]})))


;;
;; Events for editing form fields
;;


(defn valid-path? [path]
  (and (seq path)
       (every? number? path)))


(rf/reg-event-db ::select-form-element-for-edit
  (fn [db [_ id]]
    (-> db
        (assoc-in [::form-schema :id-of-selected-form-el] id)
        (p/dissoc-in [::form-schema :form-field-search-open?]))))

(rf/reg-event-db ::change-locked-when-signed-off
  (fn [db [_ new-value]]
    (-> db
        (assoc-in [::form-schema :locked-when-signed-off?] new-value))))


(defn decrease-order-for-child-elements-if-greater-than [order form-el]
  (reduce-kv
    (fn [m k v]
      (let [new-val (if (and (form-editor-util/child-key? k)
                             (> (:order v) order))
                      (update v :order dec)
                      v)]
        (assoc m k new-val)))
    {}
    form-el))


(defn replace-path-head [new-head path]
  (->> path
       (map-indexed (fn [i x] (nth new-head i x)))
       vec))


(defn update-paths-of-child-elements [new-path form-el]
  (reduce-kv
    (fn [m k v]
      (let [new-val (if (form-editor-util/child-key? k)
                      (update v :path (partial replace-path-head new-path))
                      v)]
        (assoc m k new-val)))
    {}
    form-el))
(rf/reg-event-db ::remove-field-from-condition
  (fn [db [_ data]]
    (let [editor-data       (-> (get-in db [::form-schema :editor-data 0])
                                form-schemas-util/find-condition-paths)
          extract-attribute (-> data
                                form-schemas-util/extract-attribute-fields)]
      (reduce (fn [acc a]
                (reduce (fn [db-acc f]
                          (form-schemas-util/update-db-after-delete db-acc
                                                                    {:editor-data db-path-to-editor-data
                                                                     :path        a
                                                                     :field       f}))
                        acc
                        extract-attribute))
              db
              editor-data))))

(rf/reg-event-db ::remove-initial-form-element
  (fn [db [_ {:keys [path order]}]]
    (if (valid-path? path)
      (-> db
          (p/dissoc-in (path->db-path path))
          (update-in (path->db-path (pop path))
                     (partial decrease-order-for-child-elements-if-greater-than order)))
      db)))

(rf/reg-event-fx ::remove-form-element
  (fn [_ [_ p]]
    {:dispatch-n [[::remove-field-from-condition p]
                  [::remove-initial-form-element p]]}))

(rf/reg-event-db ::edit-attrs-of-form-el
  (fn [db [_ path attr-changes]]
    (if (valid-path? path)
      (-> db
          (update-in (conj (path->db-path path) :attributes)
                     (fn [curr-attrs]
                       (let [updates         (p/filter-vals some? attr-changes)
                             keys-to-retract (-> (p/filter-vals nil? attr-changes)
                                                 keys)]
                         (-> (apply dissoc curr-attrs keys-to-retract)
                             (merge updates))))))
      db)))


(rf/reg-event-db ::edit-val-in-tuple-attr
  (fn [db [_ {:keys [path] :as form-field} {:keys [index value attr]}]]
    (if (valid-path? path)
      (let [current-vals (get-in form-field [:attributes attr])
            path-to-attr (conj (path->db-path path) :attributes attr)]
        (cond
          (nil? value)
          (update-in db path-to-attr #(-> % vec (form-schemas-util/drop-index index)))

          (empty? current-vals)
          (assoc-in db path-to-attr [value])

          :else
          (update-in db path-to-attr #(-> % vec (assoc index value)))))
      db)))


(rf/reg-event-db ::edit-form-element
  (fn [db [_ path changes]]
    (if (valid-path? path)
      (update-in db (path->db-path path) merge changes)
      db)))


(defn update-next-id [db number-to-add]
  (update-in db [::form-schema :next-id] + number-to-add))

(defn map-children [f element]
  (->> element
       (map (fn [[k v]]
              (if (integer? k)
                [k (f v)]
                [k v])))
       (into {})))


(defn increment-order-for-children [element order]
  (map-children
    (fn [child]
      (update child :order #(if (>= % order)
                              (inc %)
                              %)))
    element))


(rf/reg-event-fx ::add-new-child-element
  (fn [{:keys [db]} [_ {:keys [path] :as parent-element} type-for-new-el select-element-after? order]]
    (if (valid-path? path)
      (let [next-id          (-> db ::form-schema :next-id)
            path-for-new-el  (conj path next-id)
            ;; add a child element for the new child element when it's applicable
            grand-child-type (form-schemas-util/type->default-child-type type-for-new-el)
            skeleton         (form-schemas-util/default-skeleton type-for-new-el
                                                                 path-for-new-el
                                                                 (or order (order-number-for-new-child parent-element))
                                                                 true
                                                                 (inc next-id)
                                                                 grand-child-type)]
        (p/assoc-if {:db (cond-> db
                           (some? order) (update-in (path->db-path path) increment-order-for-children order)
                           true (assoc-in (path->db-path path-for-new-el) skeleton)
                           ;; Bump next-id by 2 when two new elements are created
                           true (update-next-id (if grand-child-type 2 1))
                           select-element-after? (assoc-in [::form-schema :id-of-selected-form-el] next-id))}
                    ;; If order is set, we are inserting the element below an element the user sees,
                    ;; so we don't need to scroll anywhere.
                    :dispatch (when (and (= :section type-for-new-el)
                                         (nil? order))
                                [::scroll-to-bottom])))
      {})))


(defn- update-order-for-children [parent-element from-order-ix to-order-ix]
  (reduce-kv (fn [m k v]
               (if (number? k)
                 (assoc m k (assoc v :order (dnd/new-ix from-order-ix to-order-ix (:order v))))
                 (assoc m k v)))
             {}
             parent-element))


(defn- type-category [type]
  (case type
    :sign-off/declaration-section-v2 :section
    :sign-off/declaration-subsection :subsection
    (:section :subsection :form-row :form) type
    :row-element))

(def valid-category-parents
  {:section     #{:form}
   :subsection  #{:section}
   :form-row    #{:subsection :section}
   :row-element #{:form-row}})

(defn- valid-move? [from-element to-parent]
  (let [parent-cat (->> to-parent :type type-category)
        from-cat   (->> from-element :type type-category)]
    ((valid-category-parents from-cat) parent-cat)))


(rf/reg-event-db ::move-form-element
  (fn [db [_ from-path to-path]]
    (let [from-full-path (path->db-path from-path)
          to-full-path   (path->db-path to-path)
          to-parent      (->> (pop to-path)
                              path->db-path
                              (get-in db))
          parent-path    (pop to-full-path)
          parent-element (get-in db parent-path)
          same-parent?   (= parent-path (pop from-full-path))
          to-order-ix    (get-in db (conj to-full-path :order))
          from-element   (cond->> (merge (get-in db from-full-path)
                                         (when (not same-parent?)
                                           {:path  (conj (pop to-path) (last from-path))
                                            :order to-order-ix}))
                           (not same-parent?) (update-paths-of-child-elements (pop to-path)))]
      (cond
        (or (not-every? valid-path? [from-path to-path])
            (not (valid-move? from-element to-parent)))
        db

        same-parent?
        (update-in db parent-path update-order-for-children (:order from-element) to-order-ix)

        :else
        (-> db
            ;; use 'current-max-order-number + 1' as from-order-ix when same-parent? = false
            (update-in parent-path update-order-for-children (order-number-for-new-child parent-element) to-order-ix)
            (assoc-in (path->db-path (:path from-element)) from-element)
            (p/dissoc-in from-full-path))))))


(defn- filter-attrs-for-new-type
  "Do not remove uneditable attrs when changing field type.
  Otherwise we could remove integration-id (or some other uneditable attr) when changing field type"
  [attrs new-type]
  (let [uneditable-attrs-in-form-editor (->> (vals form-schemas-util/config-for-types)
                                             (mapcat :editable-attrs)
                                             set
                                             (set/difference (-> attrs keys set)))]
    (p/filter-keys (-> (form-schemas-util/editable-attrs-for-type new-type)
                       set
                       (set/union uneditable-attrs-in-form-editor))
                   attrs)))


(defn child-valid-for-type? [parent-type {:keys [type]}]
  (-> (get-in form-schemas-util/config-for-types [parent-type :possible-child-types])
      set
      (contains? type)))


(rf/reg-event-db ::change-field-type
  (fn [db [_ {:keys [path order]} new-type]]
    (if (valid-path? path)
      (let [form-element          (get-in db (path->db-path path))
            old-form-element      (->> (update form-element :attributes filter-attrs-for-new-type new-type)
                                       ;; Remove invalid children elements
                                       (reduce-kv (fn [acc k v]
                                                    (if (or (not (form-editor-util/child-key? k))
                                                            (child-valid-for-type? new-type v))
                                                      (assoc acc k v)
                                                      acc))
                                                  {}))
            next-id               (-> db ::form-schema :next-id)
            child-type            (when (empty? (form-editor-util/form-el->children old-form-element))
                                    (form-schemas-util/type->default-child-type new-type))
            skeleton-for-new-type (form-schemas-util/default-skeleton new-type
                                                                      path
                                                                      order
                                                                      nil
                                                                      next-id
                                                                      child-type)]
        (-> db
            (assoc-in (path->db-path path)
                      (p/deep-merge old-form-element skeleton-for-new-type))
            (update-next-id (if child-type 1 0))))
      db)))

(rf/reg-sub ::available-party-roles
  :<- [::gas/group-id]
  :<- [::entities/context]
  :<- [:language]
  (fn [[group-id ctx lang] _]
    (->> (entities/find-entities ctx {:group.config/group group-id})
         (mapcat :group.config/applicable-party-roles)
         (map (fn [party-role]
                {:role-key (:party-role/key party-role)
                 :label    (role-model/party-role-name party-role lang)}))
         distinct
         (sort-by :label))))

(def imported-attributes
  "Which attributes to copy over when using an existing field"
  #{:field
    :description
    :unit
    :unit-label})

(rf/reg-event-fx ::set-selected-existing-field
  (fn [{:keys [db]} [_ {:keys [labels tag type] :as field-def} path]]
    (let [schema       (-> db ::form-schema :editor-data)
          form-element (get-in schema path)]
      {:db         (-> db
                       (assoc-in (conj (path->db-path path) :existing-field) field-def)
                       (p/dissoc-in (conj (path->db-path path) :conflicting-field)))
       :dispatch-n [[::change-field-type form-element (if (= type :number)
                                                        :number-input
                                                        tag)]
                    [::edit-attrs-of-form-el path (assoc (select-keys field-def imported-attributes)
                                                         :label (first labels))]
                    [::validate-field-key-locally path (:field field-def)]]})))


(defn find-local-conflicting-field [db path field-key]
  (let [omitted-id (get-in db (conj (path->db-path path) :id))]
    (form-schemas-util/find-duplicate-field field-key
                                            omitted-id
                                            (get-in db [::form-schema :editor-data 0]))))


(rf/reg-event-db ::validate.success
  (fn [db [_ path _ {:keys [result]}]]
    (let [conflict-path (conj (path->db-path path) :conflicting-field)]
      (if result
        (assoc-in db conflict-path result)
        (p/dissoc-in db conflict-path)))))


(rf/reg-event-fx ::validate-field-key
  (fn [_ [_ path field-key authority-group-id]]
    {:comm/command {:command    :form/find-form-field-def-by-field-key
                    :data       (util/mmap field-key authority-group-id)
                    :on-success [::validate.success path]}}))


(rf/reg-event-db ::validate-field-key-locally
  (fn [db [_ path field-key]]
    (let [conflict-path     (conj (path->db-path path) :locally-conflicting-field)
          duplicating-field (find-local-conflicting-field db path field-key)]
      (if duplicating-field
        (assoc-in db conflict-path duplicating-field)
        (p/dissoc-in db conflict-path)))))
